module.exports = __webpack_public_path__ + "img/lang-ru.4655421e.png";